import React from 'react';
import clsx from 'clsx';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import paging, { pagingConfig, pagingHookConfig } from '@/hooks/paging';
import { findMatch } from '@/utils/resultsHelper';
import DropdownSegment from '@/components/DropdownSegment';
import { fetchRoles } from '../actions';
import { adminPermissionsCount } from '../helper';

const listItems = (roles, withPermissions, byName, intl) => roles.map((role) => (({
  key: `roles_${role.code}`,
  text: role.name,
  value: byName ? role.name : role.code,
  description: role.metrics && withPermissions ? intl.formatMessage({ id: 'permissions.count.succinct' }, {
    total: role.metrics.all_permissions,
    admin: adminPermissionsCount(role),
  }) : null,
})));

const RolesDropdown = ({
  category,
  value,
  readStatus,
  roles,
  disabled,
  fetchRoleList,
  onChange,
  withDescription,
  withPermissions,
  description,
  fluid,
  clearable,
  className,
  placeholder = 'roles.select.placeholder',
  size = 'large',
  byName,
}) => {
  const intl = useIntl();
  paging.useFetchByCategory(fetchRoleList, category, readStatus, { ...pagingHookConfig(), ...pagingConfig(10000) });

  return (
    <>
      <Dropdown
        className={clsx('aridhia-roles-dropdown', 'max-content', className)}
        id="role_dropdown"
        options={listItems(roles, withPermissions, byName, intl)}
        disabled={disabled}
        value={value}
        clearable={clearable}
        size={size}
        selection
        fluid={fluid}
        loading={readStatus === states.PENDING}
        placeholder={intl.formatMessage({ id: placeholder })}
        onChange={onChange}
      />
      {withDescription && description && (
      <DropdownSegment className="aridhia-roles-dropdown-segment" messageText={description} markdown />
      )}
    </>
  );
};

export const mapStateToProps = ({
  roles: { roles },
}, { byName, category, value }) => {
  const { results, readErrors, readStatus } = roles[category];
  const role = findMatch(results, value, byName ? 'name' : 'code');

  return {
    description: role?.description || '',
    readErrors,
    readStatus,
    roles: results,
  };
};

const mapDispatchToProps = {
  fetchRoleList: fetchRoles,
};

export default connect(mapStateToProps, mapDispatchToProps)(RolesDropdown);
